/**
 * Trunnion AI - Workflow Designer (Top-Level Container)
 * The flagship component wrapping ReactFlowProvider, toolbar, canvas, and panels.
 */

import { ReactFlowProvider } from '@xyflow/react';
import { DesignerCanvas } from './DesignerCanvas';
import { DesignerToolbar } from './DesignerToolbar';
import { NodePalette } from './panels/NodePalette';
import { NodeInspector } from './panels/NodeInspector';
import { useUIStore } from '@/stores/uiStore';

interface WorkflowDesignerProps {
  onSave: (meta: { name: string; description: string; classification: string }) => void;
  onExecute?: () => void;
  saving?: boolean;
}

export function WorkflowDesigner({ onSave, onExecute, saving }: WorkflowDesignerProps) {
  const paletteOpen = useUIStore((s) => s.paletteOpen);
  const inspectorOpen = useUIStore((s) => s.inspectorOpen);

  return (
    <ReactFlowProvider>
      <div className="flex h-full flex-col overflow-hidden rounded-xl border border-trunnion-slate-700 bg-trunnion-slate-950">
        {/* Toolbar */}
        <DesignerToolbar onSave={onSave} onExecute={onExecute} saving={saving} />

        {/* Main area: palette + canvas + inspector */}
        <div className="flex flex-1 overflow-hidden">
          {/* Node Palette */}
          {paletteOpen && <NodePalette />}

          {/* Canvas */}
          <DesignerCanvas />

          {/* Node Inspector */}
          {inspectorOpen && <NodeInspector />}
        </div>
      </div>
    </ReactFlowProvider>
  );
}
